module.exports = __webpack_public_path__ + "static/media/MAI_Rose.a3903aa9.png";